import React, { useState, createContext } from "react";

export type legalAndPrivacyContextProperties = {
  currentPage: string;
  setCurrentPage: (_: string) => void;
};
export const LegalAndPrivacyContext = createContext<legalAndPrivacyContextProperties>({
  setCurrentPage: () => 44,
  currentPage: "",
});
export const LegalAndPrivacyProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentPage, setCurrentPage] = useState("legal-and-privacy");
  return (
    <LegalAndPrivacyContext.Provider value={{ currentPage, setCurrentPage }}>
      {children}
    </LegalAndPrivacyContext.Provider>
  );
};
